module.exports = __webpack_public_path__ + "img/imgRecomendationSection.e89b5cb8.webp";